import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import AssigneePicker from "../AssigneePicker";
import { STATUS_META, PRIORITY_META } from "../ui-bits";

export default function TaskMetaSection({ task, users, patch }) {
  return (
    <div className="p-4 grid grid-cols-2 gap-3 border-b border-border">
      <div>
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Status</p>
        <Select value={task.status} onValueChange={(v) => patch({ status: v })}>
          <SelectTrigger data-testid="panel-status-select" className="h-8 text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(STATUS_META).map(([k, m]) => (
              <SelectItem key={k} value={k} data-testid={`panel-status-${k}`}>
                <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full" style={{ backgroundColor: m.color }} />{m.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Priority</p>
        <Select value={task.priority} onValueChange={(v) => patch({ priority: v })}>
          <SelectTrigger data-testid="panel-priority-select" className="h-8 text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(PRIORITY_META).map(([k, m]) => (
              <SelectItem key={k} value={k} data-testid={`panel-priority-${k}`}>
                <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full" style={{ backgroundColor: m.color }} />{m.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Start date</p>
        <input data-testid="panel-start-date" type="date" value={task.start_date || ""} onChange={(e) => patch({ start_date: e.target.value || null })}
          className="w-full h-8 px-2 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Due date</p>
        <input data-testid="panel-due-date" type="date" value={task.due_date || ""} onChange={(e) => patch({ due_date: e.target.value || null, tz_offset: -new Date().getTimezoneOffset() })}
          className="w-full h-8 px-2 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Due time</p>
        <input data-testid="panel-due-time" type="time" value={task.due_time || ""} onChange={(e) => patch({ due_time: e.target.value || null, tz_offset: -new Date().getTimezoneOffset() })}
          className="w-full h-8 px-2 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
      </div>
      <div className="col-span-2">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">Assignees</p>
        <AssigneePicker users={users} selected={task.assignees || []}
          onToggle={(id) => {
            const cur = task.assignees || [];
            patch({ assignees: cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id] });
          }}
          testid="panel-assignees" menuTestid="panel-assignees-menu" optionPrefix="panel-assignee" placeholder="Unassigned" fullWidth />
      </div>
    </div>
  );
}
